const XmarkWhite = ({ className }: { className: string }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M12.7086 4.70859C13.0992 4.31797 13.0992 3.68359 12.7086 3.29297C12.318 2.90234 11.6836 2.90234 11.293 3.29297L8.00234 6.58672L4.70859 3.29609C4.31797 2.90547 3.68359 2.90547 3.29297 3.29609C2.90234 3.68672 2.90234 4.32109 3.29297 4.71172L6.58672 8.00234L3.29609 11.2961C2.90547 11.6867 2.90547 12.3211 3.29609 12.7117C3.68672 13.1023 4.32109 13.1023 4.71172 12.7117L8.00234 9.41797L11.2961 12.7086C11.6867 13.0992 12.3211 13.0992 12.7117 12.7086C13.1023 12.318 13.1023 11.6836 12.7117 11.293L9.41797 8.00234L12.7086 4.70859Z"
      fill="white"
    />
  </svg>
);

export default XmarkWhite;
